import { Skeleton } from 'antd'
import Styles from './DesignWizardField.module.scss'

export const Loading = () => (
  <div className={Styles.loadingContainer}>
    <Skeleton active paragraph={false} className={Styles.loadingPreview} />
  </div>
)
